import React, { Component, Fragment } from 'react';
import { FieldTypes, SelectOptionFields, textNumberField, linkField } from 'drapcode-constant';
import { Form, Formik, getIn } from 'formik';
import CollectionAccordian from '../CollectionAccordian';
import { fieldSchemaValidation } from '../../../common/formElements/CollectionSectionType';
import FieldFormFields from './FieldFormFields';

class FieldForm extends Component {
  state = {
    selectedField: this.props.createSchemaForFields()
      ? this.props.createSchemaForFields().type
      : 'text',
    isNewOption: false,
    tags: this.props.createSchemaForFields()
      ? this.props.createSchemaForFields().staticOptions.map((opt) => ({ id: opt, text: opt }))
      : [],
  };

  handleTagDelete = (i) => {
    const tags = this.state.tags.filter((tag, index) => index !== i);
    this.setState({ tags });
  };

  handleTagAddition = (tag) => {
    this.setState({
      tags: [...this.state.tags, tag],
    });
  };

  deleteField = () => {
    this.setState({ tags: [] });
    this.props.deleteField();
  };

  changeFieldType = (newField) => {
    this.setState({ selectedField: newField });
  };

  render() {
    const {
      title,
      isMultiSelect,
      type,
      isPluginField,
      showCollectionFieldDeleteLoader,
      createSchemaForFields,
      projectDetail,
      fieldName,
      collectionOptions,
      projectCollections,
      restrictEdit,
      fieldFlag,
      roles,
      readRoles,
      writeRoles,
    } = this.props;

    const { color, email } = FieldTypes;
    const { selectedField, tags } = this.state;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={createSchemaForFields()}
        validationSchema={fieldSchemaValidation()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          values.staticOptions = tags.map((e) => e.text);
          values.type = selectedField;
          if (SelectOptionFields.includes(values.type)) {
            values.refCollection.isShowAsText =
              values.refCollection.displayType === 'asText' ? true : false;

            values.refCollection.isShowAsRadioOrCheckBox =
              values.refCollection.displayType === 'asRadioOrCheckbox' ? true : false;

            const displayType = values.refCollection.displayType;
            values.refCollection.displayType =
              displayType === 'asText' || displayType === 'asRadioOrCheckbox'
                ? 'dropdown'
                : displayType;
          }
          values.unique =
            values.unique &&
            [...textNumberField, color.id, email.id, ...linkField].includes(values.type)
              ? true
              : false;

          this.props.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
          <Form>
            <CollectionAccordian
              title={title}
              fieldName={fieldName}
              isMultiSelect={isMultiSelect}
              restrictEdit={restrictEdit}
              type={type}
              isPluginField={isPluginField}
              isSubmitting={isSubmitting}
              deleteField={this.deleteField}
              numberOfFiles={getIn(values, 'validation.noAllowedFiles')}
              showCollectionFieldDeleteLoader={showCollectionFieldDeleteLoader}
              fieldFlag={fieldFlag}
              readRoles={readRoles}
              writeRoles={writeRoles}
            >
              <div className="row">
                <FieldFormFields
                  values={values}
                  setFieldValue={setFieldValue}
                  selectedField={selectedField}
                  setFieldTouched={setFieldTouched}
                  projectCollections={projectCollections}
                  changeFieldType={this.changeFieldType}
                  handleTagDelete={this.handleTagDelete}
                  handleTagAddition={this.handleTagAddition}
                  tags={tags}
                  fieldName={fieldName}
                  collectionOptions={collectionOptions}
                  projectDetail={projectDetail}
                  isPluginField={isPluginField}
                  roles={roles}
                />
              </div>
            </CollectionAccordian>
          </Form>
        )}
      </Formik>
    );
  }
}

export default FieldForm;
